import { TeamColorInfo } from '../types/seatTypes';

/**
 * 팀별 색상 매핑 (팀명 → 색상)
 */
export const TEAM_COLORS: Record<string, string> = {
  // 개발본부 - 파란/보라 계열
  플랫폼개발팀: '#bbdefb',
  서비스개발팀: '#c5cae9',

  // AI/DX 사업본부 - 노란/주황 계열
  미디어사업팀: '#fff9c4',
  글로벌사업팀: '#ffe0b2',

  // 헬스케어사업본부 - 핑크/살구 계열
  서비스사업팀: '#f8bbd9',
  사업관리팀: '#F9C1C1',

  // 경영본부 - 민트/청록 계열
  경영지원팀: '#b2ebf2',
  재무회계팀: '#e0f2f1',

  // 기술연구소 - 남색 계열
  AI개발팀: '#EFEAF7',

  // 제주지사 - 그린 계열
  제주지사: '#c8e6c9',

  // CEO - 코랄 계열
  CEO: '#ffccbc',

  // 본부장
  본부장: '#b0bec5',
} as const;

/**
 * 팀 색상 리스트 (UI용)
 */
export const TEAM_COLOR_LIST: readonly TeamColorInfo[] = [
  // 개발본부 - 파란/보라 계열
  { teamName: '플랫폼개발팀', color: '#bbdefb', department: '개발본부' },
  { teamName: '서비스개발팀', color: '#c5cae9', department: '개발본부' },

  // AI/DX 사업본부 - 노란/주황 계열
  { teamName: '미디어사업팀', color: '#fff9c4', department: 'AI/DX 사업본부' },
  { teamName: '글로벌사업팀', color: '#ffe0b2', department: 'AI/DX 사업본부' },

  // 헬스케어사업본부 - 핑크/살구 계열
  { teamName: '서비스사업팀', color: '#f8bbd9', department: '헬스케어사업본부' },
  { teamName: '사업관리팀', color: '#F9C1C1', department: '헬스케어사업본부' },

  // 경영본부 - 민트/청록 계열
  { teamName: '경영지원팀', color: '#b2ebf2', department: '경영본부' },
  { teamName: '재무회계팀', color: '#e0f2f1', department: '경영본부' },

  // 기술연구소 - 남색 계열
  { teamName: 'AI개발팀', color: '#EFEAF7', department: '기술연구소' },

  // 제주지사 - 그린 계열
  { teamName: '제주지사', color: '#c8e6c9', department: '제주지사' },

  // CEO - 코랄 계열
  { teamName: 'CEO', color: '#ffccbc', department: 'CEO' },

  // 본부장 - 그레이 계열
  { teamName: '본부장', color: '#DBC1AC', department: '본부장' },
];

/**
 * 공석용 기본 색상 (연한 회색)
 */
export const EMPTY_SEAT_COLOR = '#fafafa';

/**
 * 팀 이름으로 색상 찾기
 */
export const getTeamColor = (teamName: string, department?: string): string => {
  if (department) {
    const team = TEAM_COLOR_LIST.find(
      (t) => t.teamName === teamName && t.department === department,
    );
    if (team) return team.color;
  }

  const team = TEAM_COLOR_LIST.find((t) => t.teamName === teamName);
  return team?.color || EMPTY_SEAT_COLOR;
};

/**
 * 색상으로 팀 정보 찾기
 */
export const getTeamByColor = (color: string): TeamColorInfo | undefined => {
  return TEAM_COLOR_LIST.find((t) => t.color === color);
};

/**
 * 본부별 그룹화된 팀 색상 리스트
 */
export const getTeamColorsByDepartment = (): Record<string, TeamColorInfo[]> => {
  return TEAM_COLOR_LIST.reduce((acc, team) => {
    if (!acc[team.department]) {
      acc[team.department] = [];
    }
    acc[team.department].push(team);
    return acc;
  }, {} as Record<string, TeamColorInfo[]>);
};
